export type ValueOf<T> = T[keyof(T)];

export function getTypedEntries<T extends object>(
  item: T
): [keyof(T), ValueOf<T>][] {
  return Object.entries(item) as [keyof(T), ValueOf<T>][];
}
